import { Heart } from "lucide-react";
import { useFavorites } from "../lib/favorites";

export default function FavoriteButton({ id, className = "", size = "w-4 h-4" }) {
  const { ids, toggle } = useFavorites();
  const on = ids.has(id);
  return (
    <button
      type="button"
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggle(id); }}
      aria-label={on ? "Remove from saved" : "Save car"}
      data-testid={`favorite-btn-${id}`}
      data-active={on}
      className={`rounded-full bg-black/60 backdrop-blur border border-white/10 hover:border-[#D4AF37] transition-[border-color,transform] active:scale-90 flex items-center justify-center ${className}`}
    >
      <Heart key={on ? "on" : "off"} className={`${size} transition-colors ${on ? "fill-[#D4AF37] text-[#D4AF37] heart-pop" : "text-white"}`} />
    </button>
  );
}
